'use strict';

const Analytics = require('./analytics');

function returnFormatedPaymentMethod (method) {
    const refundMethodOptions = {
        'wireTransfer': 'wire_transfer',
        'returnCard': 'e_reso_card',
        'sameCommerceMethod': 'same_payment_method',
        'RE_SAME_COMMERCE_METHOD': 'true',
    };
    return refundMethodOptions[method] || 'false';
}

class Refund extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'Refund';
        super.init(globalContainer, helperContainer);
        this.prepareRefundObservers();
        this.itemSkus = [];
        this.doubleRun = false;
    }

    getFormattedShippingMethodFromKey (key) {
        const shippingMethods = {
            'HOME': 'home',
            'STORE': 'shop',
            'PICKUPPOINT': 'pickup_point'
        };

        return shippingMethods[key];
    }

    prepareRefundObservers () {
        var _self = this;

        $('body').on('analytics:selectedReturnReason', (_e, data) => {
            _self.itemSkus = [];
            var productLineItems = data.products.productsInfo.productInfoLineItem;
            for (let i = 0; i < productLineItems.length; i++) {
                let productLineItem = productLineItems[i].returnDataForProduct;
                if (productLineItem.returnReasonId !== '-1') {
                    let refundMotivation = $(`[data-reason-id='${productLineItem.returnReasonId}']`).data('analytics-value');
                    if (refundMotivation) {
                        refundMotivation = refundMotivation.toLowerCase().replace(/ /g, '_');
                    }
                    let sku = _self.helper.getFormatSku(productLineItems[i].sku);

                    _self.itemSkus.push(sku);
                    _self.quickImpressionSender.pushRefundOptionMotivationSelect(refundMotivation, data.position, sku);
                }
            }
        });

        $('body').on('analytics:selectedExchangeFlow', function (_e, data) {
            _self.quickImpressionSender.pushExchangeOptionSelect(data.touchpoint, data.motivation);
        });

        $('body').on('analytics:exchangeMotivationSelected', function (_e, data) {
            _self.quickImpressionSender.pushExchangeProductOption(data.change, data.sku, data.touchpoint);
        });

        $('body').on('analytics:exchangeShippingSelect', function (e, data) {
            const position = $('.analytics.helperData').attr('data-page-type') === 'refund' ? 'refund' : 'order';
            let skus = data && data.skus ? data.skus : '';
            if (!skus) {
                const skusList = [];
                $('.js-returnOpen-exchangeList .cc-returnOpen-productCard, .cc-returnOpen-productCard.js-exchangeOpen-productCard').each((index, element) => {
                    const currentCard = $(element);
                    const sku = _self.helper.getFormatSku(currentCard.data('sku'));
                    skusList.push(sku);
                });
                skus = skusList.join('-');
            }

            const shippingMethodKey = data && data.shippingMethodKey ? data.shippingMethodKey : null;
            const shippingMethod = _self.getFormattedShippingMethodFromKey(shippingMethodKey) || shippingMethodKey;

            if (shippingMethod && skus) {
                _self.quickImpressionSender.pushExchangeOptionShippingMethod(shippingMethod, position, skus);
            }
        });

        $('body').on('analytics:returnShippingSelect', function (e, data) {
            const position = $('.analytics.helperData').attr('data-page-type') || 'refund';
            const shippingMethodKey = data && data.shippingMethodKey ? data.shippingMethodKey : null;
            const shippingMethod = _self.getFormattedShippingMethodFromKey(shippingMethodKey) || shippingMethodKey;
            const skus = _self.itemSkus && _self.itemSkus.length ? _self.itemSkus.join('-') : '';

            if (shippingMethod && skus) {
                _self.quickImpressionSender.pushRefundOptionShippingMethod(
                    shippingMethod,
                    position,
                    skus
                );
            }
        });

        $('body').on('analytics:selectedRefundMethod', function (_e, data) {
            _self.quickImpressionSender.pushRefundOptionPaymentMethod(
                returnFormatedPaymentMethod(data.selectedRefundMethod),
                data.position,
                _self.itemSkus.join('-')
            );
        });

        $('body').on('analytics:returnConfirmation', function (_e, data) {
            const { orderNo, selectedRefundMethod, selectedShippingMethod, position, exchangeSkus } = data;
            const formattedExchangeSkus = (exchangeSkus || []).map(sku => _self.helper.getFormatSku(sku));
            const allSkus = Array.from(new Set([..._self.itemSkus, ...formattedExchangeSkus]));

            const shippingMethodOptions = {
                'HOME': 'home',
                'STORE': 'shop',
                'PICKUPPOINT': 'pickup_point'
            };

            const shippingMethod = shippingMethodOptions[selectedShippingMethod] || 'home';
            const paymentMethod = selectedShippingMethod === 'STORE' ? '0' : returnFormatedPaymentMethod(selectedRefundMethod);

            _self.quickImpressionSender.pushRefundOptionConfirmation(
                allSkus.join('-'),
                position,
                shippingMethod,
                paymentMethod,
                orderNo
            );
            _self.itemSkus = [];
        });

        // 6.33 FIND YOUR STORE & 6.34 FIND YOUR STORE - GEOLOCATION -- For return a product flow
        $('body').on('analytics:refundFindYourStore', function (_e, data) {
            if (data.action === 'geolocation') {
                // to prevent geolocation double triggering
                if (!_self.doubleRun) {
                    // wait the dom to load
                    setTimeout(function () {
                        let location = $($('.cc-findInStoreModal-storeName .store-name').get(0)).text().replaceAll(',', '');
                        _self.quickImpressionSender.pushFindStoreGeolocationImpressionCheckout(
                            _self.helper.formatNameForAnalytics(location),
                            _self.itemSkus.join('-'),
                            'search_for_return',
                            null
                        );
                    }, 1000);
                }
                _self.doubleRun = !_self.doubleRun;
            } else {
                _self.quickImpressionSender.pushFindStoreFindInteraction(
                    data.where,
                    _self.itemSkus.join('-'),
                    'search_for_return',
                    null
                );
            }
        });

        // 6.126 STORE LOCATOR - ACTIONS -- For return a product flow
        $('body').on('analytics:refundStoreActions', function (_e, data) {
            _self.quickImpressionSender.pushFindStoreClickResultAction(
                data.action,
                _self.helper.formatNameForAnalytics(data.store),
                _self.itemSkus.join('-'),
                'search_for_return',
            );
        });
    }
}

const obj = new Refund();
module.exports = obj;
